import { render, staticRenderFns } from "./FolderLeftItem.vue?vue&type=template&id=138d5233&scoped=true&"
import script from "./FolderLeftItem.vue?vue&type=script&lang=js&"
export * from "./FolderLeftItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderLeftItem.vue?vue&type=style&index=0&id=138d5233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d5233",
  null
  
)

export default component.exports